const partVehicles = [
    'Osobowe',
    'Dostawcze',
    'Motocykle',
    'Ciężarowe',
    'Pojazdy na części',
    'Pozostałe',
]

module.exports = partVehicles